import { useMutateOnRefresh } from '@va/dashboard/util-hooks';
import { useNumberOfVisitorByDay } from './apiClient';
import TrafficChartCard from './TrafficChartCard';

const VisitorsByDayChart = () => {
  const { data, isLoading, mutate } = useNumberOfVisitorByDay();
  const { isManualRefreshing } = useMutateOnRefresh(mutate);
  return (
    <TrafficChartCard data={data} isLoading={isManualRefreshing || isLoading} baseKey='trafficVisitorsByWeekDays' />
  );
};

export default VisitorsByDayChart;
